import { CartItemSource } from '@legalzoom/cart-sdk';
import { of, Subject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ProductName } from '../constants/product-domain';
import { Chapter, PagePath } from '../models/page-model';
import { ConstantsService } from './constants.service';
import { CartCreationStatus } from './event.service';
import { ProductConfigurationIds } from '../models/cart-model';
import * as i0 from "@angular/core";
import * as i1 from "@legalzoom/business-formation-sdk";
import * as i2 from "@legalzoom/web-session-sdk";
import * as i3 from "../state/app/app.service";
import * as i4 from "@angular/router";
import * as i5 from "./questionnaire/questionnaire.service";
import * as i6 from "@legalzoom/cart-sdk";
import * as i7 from "./user-cart.service";
import * as i8 from "./questionnaire/questionnaire-mapping.service";
import * as i9 from "@legalzoom/product-sdk";
import * as i10 from "./package.service";
import * as i11 from "@legalzoom/questionnaire-storage-sdk";
import * as i12 from "@legalzoom/questionnaire-answer-sdk";
import * as i13 from "./event.service";
import * as i14 from "./tracking/tracking.service";
import * as i15 from "./tracking/track-sem-data.service";
import * as i16 from "ngx-cookie/src/cookie.service";
export class PrepareCartService {
    constructor(queueService, webSessionService, appService, trackJS, utilitiesService, router, questionnaireService, cartService, userCartService, questionnaireMappingService, productService, packageService, questionnaireStorageService, questionnaireAnswerService, eventService, trackingService, trackSemDataService, cookieService) {
        this.queueService = queueService;
        this.webSessionService = webSessionService;
        this.appService = appService;
        this.trackJS = trackJS;
        this.utilitiesService = utilitiesService;
        this.router = router;
        this.questionnaireService = questionnaireService;
        this.cartService = cartService;
        this.userCartService = userCartService;
        this.questionnaireMappingService = questionnaireMappingService;
        this.productService = productService;
        this.packageService = packageService;
        this.questionnaireStorageService = questionnaireStorageService;
        this.questionnaireAnswerService = questionnaireAnswerService;
        this.eventService = eventService;
        this.trackingService = trackingService;
        this.trackSemDataService = trackSemDataService;
        this.cookieService = cookieService;
        this.parentComponentName = '';
        this.promoCodeApplyErrorEvent = new Subject();
        this.shouldRemovePromocode = false;
    }
    prepareQueueEntries() {
        return {
            name: 'prepareQueueEntries ' + this.constructor.name,
            pre: () => {
                return of(null);
            },
            post: () => {
                if (this.appService.sessionId && this.appService.accessToken && this.appService.customerId) {
                    // user already exists
                }
                else {
                    this.queueService.add(this.prepareGuestCustomerAndSession());
                    this.queueService.add(this.utilitiesService.prepareSaveCookies(this.appService));
                }
                if (!this.appService.cartId) {
                    this.queueService.add(this.userCartService.prepareCreateNewCart());
                    this.queueService.add(this.utilitiesService.prepareSaveCookies(this.appService));
                    this.queueService.add(this.prepareUpdateQuestionnaireStorage());
                    this.queueService.add(this.prepareTrackSemDataService());
                }
                else {
                    this.eventService.updateCartCreationStatus(CartCreationStatus.Created);
                }
                this.queueService.add(this.prepareKenshooTrack());
                this.queueService.add(this.prepareRestoreLLCData());
                // this.queueService.add(this.prepareQueueForQuestStorageFillingFee());
                this.queueService.process().subscribe();
            },
            error: (error) => {
                console.log(error);
                this.trackJS.track(ProductName.LLC, this.constructor.name, error);
                return of(null);
            }
        };
    }
    prepareQueueForQuestStorageFillingFee() {
        return {
            name: 'prepareQueueEntries ' + this.constructor.name,
            pre: () => {
                return of(null);
            },
            post: () => {
                this.queueService.add(this.prepareUpdateQuestionnaireStorage());
                this.queueService.add(this.prepareSaveAndGetMappedUserAnswers());
                this.queueService.add(this.prepareGetAvailablePackagesWithFilingFees());
                this.queueService.process().subscribe();
            },
            error: (error) => {
                console.log(error);
                this.trackJS.track(ProductName.LLC, this.constructor.name, error);
                return of(null);
            }
        };
    }
    prepareGuestCustomerAndSession() {
        return {
            name: 'prepareGuestCustomerAndSession ' + this.constructor.name,
            pre: () => {
                return this.webSessionService.createGuestCustomerAndSession();
            },
            post: (response) => {
                if (response) {
                    this.appService.customerId = response.customer.customerId;
                    this.appService.loginEmail = response.customer.emailId;
                    this.appService.sessionId = response.session.sessionId;
                    this.appService.accessToken = response.session.accessToken;
                    this.utilitiesService.saveCookies(this.appService.app.sessionId, this.appService.app.accessToken, this.appService.app.customerId);
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, `${this.constructor.name} called from ${this.parentComponentName}`, error);
                return of(null);
            }
        };
    }
    prepareRestoreLLCData() {
        const that = this;
        const currentUrl = this.router.url.split('/');
        return {
            name: 'prepareRestoreIncData ' + this.constructor.name,
            pre: () => {
                return of(null);
            },
            post: (response) => {
                that.questionnaireService.llc.currentView = (that.questionnaireService.llc.currentView && that.questionnaireService.llc.currentView !== '') ?
                    that.questionnaireService.llc.currentView : Chapter.Name + '/' + currentUrl[currentUrl.length - 1];
            },
            error: (error) => {
                console.log(error.message);
                return of(null);
            }
        };
    }
    prepareUpdateQuestionnaireStorage() {
        const that = this;
        return {
            name: 'prepareUpdateQuestionnaireStorage ' + this.constructor.name,
            pre: () => {
                return that.questionnaireStorageService.updateQuestionnaireStorage(that.appService.customerId, that.appService.app.processingOrderId, that.questionnaireService.llc);
            },
            post: (response) => {
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, `${this.constructor.name} called from ${this.parentComponentName}`, error);
                return of(null);
            }
        };
    }
    prepareSaveAndGetMappedUserAnswers() {
        const that = this;
        return {
            name: 'prepareSaveAndGetMappedUserAnswers ' + this.constructor.name,
            pre: () => {
                const mappedUserAnswer = that.questionnaireMappingService.doMapping(this.questionnaireService.llc, this.appService.processingOrderId);
                const userAnswerRequest = {
                    questionnaireFieldGroupAnswers: {
                        userOrderId: mappedUserAnswer.userOrderId,
                        //
                        questionnaireId: that.appService.app.questionnaireId,
                        fieldAnswers: mappedUserAnswer.fieldAnswers,
                        groupAnswers: []
                    }
                };
                return that.questionnaireAnswerService.saveAndGetMappedUserAnswers(userAnswerRequest, that.appService.app.questionnaireId, that.appService.customerId);
            },
            post: (response) => {
                that.questionnaireMappingService.questionnaireMappingResponse = response;
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, `${this.constructor.name} called from ${this.parentComponentName}`, error);
                return of(null);
            }
        };
    }
    prepareGetAvailablePackagesWithFilingFees() {
        return {
            name: 'prepareGetAvailablePackagesWithFilingFees ' + this.constructor.name,
            pre: () => {
                const customerStateAbbr = ConstantsService.getStateByName(this.questionnaireService.llc.entityState).abbr;
                const productFilingRequest = {
                    state: customerStateAbbr,
                    // to-do un-comment code when mappingservice is ready with mappingResponse variable
                    fieldAnswers: this.questionnaireMappingService.questionnaireMappingResponse.questionnaireFieldGroupAnswers.fieldAnswers,
                    groupAnswers: this.questionnaireMappingService.questionnaireMappingResponse.questionnaireFieldGroupAnswers.groupAnswers
                };
                return this.productService.getAvailablePackagesWithFilingFees(this.appService.processId, productFilingRequest, this.appService.customerId);
            },
            post: (response) => {
                this.packageService.mapPackageConfigurations(response).subscribe(result => {
                    this.packageService.packageConfigurations = result;
                });
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, `${this.constructor.name} called from ${this.parentComponentName}`, error);
                return of(null);
            }
        };
    }
    prepareKenshooTrack() {
        const that = this;
        return {
            name: 'prepareKenshooTrack ' + this.constructor.name,
            clearQueueOnError: false,
            pre: () => {
                return of(null);
            },
            post: (response) => {
                this.trackingService.sendAdConversion(PagePath.BusinessState);
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, `${this.constructor.name} called from ${this.parentComponentName}`, error);
                return of(null);
            }
        };
    }
    prepareTrackSemDataService() {
        const that = this;
        return {
            name: 'prepareTrackSemDataService ' + this.constructor.name,
            clearQueueOnError: false,
            pre: () => {
                this.trackingService.UpdateTrackingModel();
                that.trackingService.setUserOrderID(this.appService.processingOrderId);
                const kidSet = that.cookieService.get('sem_kid');
                if (kidSet) {
                    return that.trackSemDataService.track();
                }
                else {
                    return of(null);
                }
            },
            post: (response) => {
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, `${this.constructor.name} called from ${this.parentComponentName}`, error);
                return of(null);
            }
        };
    }
    prepareUpdateLoadingStatus() {
        return {
            name: 'closeModalOnQueueComplete ' + this.constructor.name,
            pre: () => {
                this.eventService.updateLoadingStatus(false);
                return of(null);
            },
            post: () => { },
            error: (error) => {
                this.trackJS.track(ProductName.LLC, 'user-cart.service', error);
                return of(null);
            }
        };
    }
    prepareChangePackage(configId) {
        const that = this;
        return {
            name: 'prepareChangePackage ' + this.constructor.name,
            pre: () => {
                const changePackageRequest = {
                    newProductConfigurationId: configId,
                    catItemSource: CartItemSource.userAction,
                    updatedBy: that.appService.app.customerId.toString(),
                    fieldAnswers: that.questionnaireMappingService.questionnaireMappingResponse.questionnaireFieldGroupAnswers.fieldAnswers,
                    groupAnswers: that.questionnaireMappingService.questionnaireMappingResponse.questionnaireFieldGroupAnswers.groupAnswers
                };
                return this.cartService.changePackage(that.appService.app.cartId, changePackageRequest, that.appService.app.customerId);
            },
            post: (response) => {
                that.userCartService.updateCartResponse = response;
                if (response) {
                    const appState = that.appService.app;
                    appState.cartId = response.cart.cartId;
                    that.appService.app = appState;
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'user-cart.service', error);
                return of(null);
            }
        };
    }
    prepareGetCartModelFromApiData() {
        const that = this;
        return {
            name: 'prepareGetCartModelFromApiData ' + this.constructor.name,
            pre: () => {
                return of(null);
            },
            post: () => {
                that.userCartService.userCart = this.userCartService.getCartModelFromApiData(that.userCartService.updateCartResponse, this.appService.getCartBalanceByCartIdResponse);
                this.userCartService.userCartChange.next(that.userCartService.userCart);
            },
            error: (error) => {
                this.trackJS.track(ProductName.LLC, 'user-cart.service', error);
                return of(null);
            }
        };
    }
    prepareUpdateCartByQuestionnaire() {
        const that = this;
        return {
            name: 'prepareUpdateCartByQuestionnaire ' + this.constructor.name,
            pre: () => {
                const updateCartRequest = {
                    cartItemSource: CartItemSource.userAction,
                    changedBy: that.appService.app.customerId.toString(),
                    fieldAnswers: that.userCartService.answerResponse !== undefined &&
                        that.userCartService.answerResponse.fieldAnswers !== undefined
                        ? that.userCartService.answerResponse.fieldAnswers
                        : null,
                    groupAnswers: that.userCartService.answerResponse !== undefined &&
                        that.userCartService.answerResponse.groupAnswers !== undefined
                        ? that.userCartService.answerResponse.groupAnswers
                        : null
                };
                return that.cartService.updateCartByQuestionnaire(that.appService.app.cartId, updateCartRequest, that.appService.app.customerId);
            },
            post: response => {
                that.userCartService.updateCartResponse = response;
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'user-cart.service', error);
                return of(null);
            }
        };
    }
    prepareGetCartBalanceByCartId(paymentMode = '', displayErrorModal = false) {
        const that = this;
        return {
            name: 'prepareGetCartBalanceByCartId ' + this.constructor.name,
            clearQueueOnError: displayErrorModal,
            pre: () => {
                return that.cartService.getCartBalanceByCartId(that.appService.app.cartId, that.appService.app.customerId);
            },
            post: response => {
                this.appService.getCartBalanceByCartIdResponse = response;
                this.appService.amount =
                    paymentMode === '3pay'
                        ? this.appService.getCartBalanceByCartIdResponse.cartInstallments
                            .firstInstallment.installmentAmount
                        : this.appService.getCartBalanceByCartIdResponse.cartBalance;
            },
            error: (error) => {
                console.log(error.message);
                // if (displayErrorModal) {
                //   this.errorResponseService.displayErrorModal();
                // }
                this.trackJS.track(ProductName.LLC, 'user-cart.service', error);
                return of(null);
            }
        };
    }
    prepareAddCartDiscountByCartId(promoCode) {
        const that = this;
        return {
            name: 'prepareAddCartDiscountByCartId ' + this.constructor.name,
            clearQueueOnError: false,
            pre: () => {
                const request = {
                    promoCode,
                    changedBy: that.appService.app.customerId.toString()
                };
                return this.cartService.addCartDiscountByCartId(that.userCartService.userCart.cartId, request, that.appService.app.customerId);
            },
            post: response => {
                that.promoCodeApplyErrorEvent.next(false);
            },
            error: (error) => {
                console.log(error.message);
                // this.eventService.updateLoadingStatus(false);
                if (error.status === 400) {
                    that.promoCodeApplyErrorEvent.next(true);
                    if (this.userCartService.userCart.promoCode && this.userCartService.userCart.promoCode.length > 0) {
                        that.shouldRemovePromocode = true;
                    }
                }
                that.trackJS.track(ProductName.LLC, 'user-cart.service', error);
                return of(null);
            }
        };
    }
    prepareCancelCartDiscount() {
        const that = this;
        return {
            name: 'prepareCancelCartDiscount ' + this.constructor.name,
            pre: () => {
                if (that.shouldRemovePromocode) {
                    const request = {
                        changedBy: that.appService.app.customerId.toString()
                    };
                    return that.cartService.cancelCartDiscount(that.userCartService.userCart.cartId, request, that.appService.app.customerId);
                }
                else {
                    return of(null);
                }
            },
            post: response => {
                that.shouldRemovePromocode = false;
            },
            error: (error) => {
                this.eventService.updateLoadingStatus(false);
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'user-cart.service', error);
                return of(null);
            }
        };
    }
    getCartWithUpdatedPackage() {
        this.queueService.add(this.prepareUpdateCartByQuestionnaire());
        this.queueService.add(this.prepareGetCartBalanceByCartId('', false));
        this.queueService.add(this.prepareGetCartModelFromApiData());
        this.queueService.process().subscribe();
    }
    savePackageAndGetCart(packageConfigId) {
        this.queueService.add([this.prepareUpdateQuestionnaireStorage(), this.prepareSaveAndGetMappedUserAnswers()]);
        this.queueService.add(this.prepareChangePackage(packageConfigId));
        this.queueService.add(this.prepareGetCartBalanceByCartId('', false));
        this.queueService.add(this.prepareGetCartModelFromApiData());
        this.queueService.add(this.prepareUpdateLoadingStatus());
        this.queueService.process().subscribe();
    }
    saveAndRefreshCart() {
        this.queueService.add([this.prepareUpdateQuestionnaireStorage(), this.prepareSaveAndGetMappedUserAnswers()]);
        this.queueService.add(this.prepareUpdateCartByQuestionnaire());
        this.queueService.add(this.prepareGetCartBalanceByCartId('', false));
        this.queueService.add(this.prepareGetCartModelFromApiData());
        this.queueService.process().subscribe();
    }
    AddProfessionalPrint() {
        this.queueService.add(this.prepareAddBpptoCart());
        this.saveAndRefreshCart();
    }
    RemoveProfessionalPrint() {
        this.queueService.add(this.prepareRemoveBppfromCart());
        this.saveAndRefreshCart();
    }
    prepareAddBpptoCart() {
        const that = this;
        return {
            pre: () => {
                const createAddCartItemRequest = {
                    productConfigurationId: ProductConfigurationIds.economyLLCShipping,
                    cartItemSource: CartItemSource.userAction,
                    addedBy: this.appService.app.customerId.toString()
                };
                return this.cartService.addCartItem(this.appService.app.cartId, createAddCartItemRequest, this.appService.app.customerId);
            },
            post: response => {
                that.userCartService.updateCartResponse = response;
            },
            error: (error) => {
                this.eventService.updateLoadingStatus(false);
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'user-cart.service', error);
                return of(null);
            }
        };
    }
    prepareRemoveBppfromCart() {
        const that = this;
        return {
            pre: () => {
                const createCancelCartItemRequest = {
                    updatedBy: this.appService.app.customerId.toString(),
                    cancelPrintingItem: true,
                    cancelSimilarProducts: false
                };
                const CartToGetBppCartItemId = that.userCartService.updateCartResponse;
                return that.cartService.cancelCartItem(that.appService.app.cartId, CartToGetBppCartItemId.cart.cartItems.find(x => x.productConfigurationId === ProductConfigurationIds.economyLLCShipping).cartItemId, createCancelCartItemRequest, that.appService.app.customerId);
            },
            post: response => {
                that.userCartService.updateCartResponse = response;
            },
            error: (error) => {
                this.eventService.updateLoadingStatus(false);
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'user-cart.service', error);
                return of(null);
            }
        };
    }
    applyPromoCode(promoCode) {
        this.queueService.add(this.prepareAddCartDiscountByCartId(promoCode));
        this.queueService.add(this.prepareCancelCartDiscount());
        this.queueService.add(this.prepareUpdateCartByQuestionnaire());
        this.queueService.add(this.prepareGetCartBalanceByCartId('', false));
        this.queueService.add(this.prepareGetCartModelFromApiData());
        this.queueService.process().subscribe();
    }
    removePromoCode() {
        this.shouldRemovePromocode = true;
        this.queueService.add(this.prepareCancelCartDiscount());
        this.queueService.add(this.prepareUpdateCartByQuestionnaire());
        this.queueService.add(this.prepareGetCartBalanceByCartId('', false));
        this.queueService.add(this.prepareGetCartModelFromApiData());
        this.queueService.process().subscribe();
    }
}
PrepareCartService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PrepareCartService_Factory() { return new PrepareCartService(i0.ɵɵinject(i1.QueueService), i0.ɵɵinject(i2.WebSessionService), i0.ɵɵinject(i3.AppService), i0.ɵɵinject(i1.TrackJsErrorLogService), i0.ɵɵinject(i1.UtilitiesService), i0.ɵɵinject(i4.Router), i0.ɵɵinject(i5.QuestionnaireService), i0.ɵɵinject(i6.CartService), i0.ɵɵinject(i7.UserCartService), i0.ɵɵinject(i8.QuestionnaireMappingService), i0.ɵɵinject(i9.ProductService), i0.ɵɵinject(i10.PackageService), i0.ɵɵinject(i11.QuestionnaireStorageService), i0.ɵɵinject(i12.QuestionnaireAnswerService), i0.ɵɵinject(i13.EventService), i0.ɵɵinject(i14.TrackingService), i0.ɵɵinject(i15.TrackSEMDataService), i0.ɵɵinject(i16.CookieService)); }, token: PrepareCartService, providedIn: "root" });
